import Component from 'vue-class-component'
import BaseComponent from '@/components/base/BaseComponent'
import {Getter} from 'vuex-class'
import {StoreNamespace} from '@/globals/StoreNamespaceGlobal'
import {CompanyDetailsResponse} from '@payroll/optimus-common'

@Component({})
export default class FooterComponent extends BaseComponent {

    private currentYear: any = new Date().getFullYear();
    private startYear: any = new Date("January 01, 2018 00:00:00").getFullYear()

    @Getter('customerDetails', StoreNamespace.AUTHENTICATION) customerDetails!: CompanyDetailsResponse

}